export const ADS = 'ADS';



// WEBPACK FOOTER //
// ./src/store/modules/ad/mutation-types.js